
import { log } from './logger.js';
import { useAppStore } from './store.js';
import { addNotification } from '../components/ezViewManager.js';

const initializedChannels = new Set();
let currentChannel = 'sonic-lounge';
let titleBannerInitialized = false;
let titleBannerResizeHandler = null;
let titleBannerObserver = null;


export function initializeTitleBannerCollapse() {
    if (titleBannerInitialized) return;
    titleBannerInitialized = true;

    const banner = document.getElementById('channel-title-banner');
    if (!banner) return;

    
    function repositionBanner() {
        const mainScreen = document.getElementById('main-screen');
        if (!mainScreen) return;

        if (window.innerWidth <= 768) {
            
            if (banner.parentElement !== document.body) {
                document.body.appendChild(banner);
            }
        } else {
            
            if (banner.parentElement !== mainScreen) {
                mainScreen.insertBefore(banner, mainScreen.firstChild);
            }
        }
    }

    
    function applyMobileStyles() {
        const commandConsole = document.getElementById('command-console');
        const mainScreen = document.getElementById('main-screen');
        const playerContainer = document.getElementById('persistent-player-container');
        const copilotInput = document.getElementById('copilot-input');
        const sendBtn = document.getElementById('copilot-send-btn');
        const emojiBtn = document.getElementById('copilot-emoji-btn');
        const gifBtn = document.getElementById('copilot-gif-btn');
        const mediaPillContainer = document.querySelector('.media-pill-container');

        if (window.innerWidth <= 768) {
            

            
            const isCollapsed = banner.classList.contains('collapsed');
            const topPosition = isCollapsed ? '5px' : '30px';
            const heightCalc = isCollapsed ? 'calc(100vh - 65px)' : 'calc(100vh - 90px)';

            
            const isMobileConsoleView = document.body.classList.contains('mobile-view-console');
            
            if (commandConsole) {
                if (!isMobileConsoleView) {
                    commandConsole.style.setProperty('top', topPosition, 'important');
                    commandConsole.style.setProperty('height', heightCalc, 'important');
                } else {
                    
                    commandConsole.style.removeProperty('top');
                    commandConsole.style.removeProperty('height');
                }
            }
            if (mainScreen) {
                mainScreen.style.setProperty('top', topPosition, 'important');
                mainScreen.style.setProperty('height', heightCalc, 'important');
            }
            if (playerContainer) {
                playerContainer.style.setProperty('top', topPosition, 'important');
                playerContainer.style.setProperty('height', heightCalc, 'important');
            }
            if (copilotInput) {
                copilotInput.style.setProperty('height', '24px', 'important');
                copilotInput.style.setProperty('max-height', '24px', 'important');
                copilotInput.style.setProperty('font-size', '0.85rem', 'important');
            }
            if (mediaPillContainer) {
                mediaPillContainer.style.setProperty('height', '24px', 'important');
                mediaPillContainer.style.setProperty('min-height', '24px', 'important');
                mediaPillContainer.style.setProperty('max-height', '24px', 'important');
            }
            if (sendBtn) {
                sendBtn.style.setProperty('height', '24px', 'important');
                sendBtn.style.setProperty('width', '24px', 'important');
                sendBtn.style.setProperty('min-width', '24px', 'important');
                sendBtn.style.setProperty('max-width', '24px', 'important');
                sendBtn.style.setProperty('min-height', '24px', 'important');
                sendBtn.style.setProperty('max-height', '24px', 'important');
                sendBtn.style.setProperty('font-size', '0.85rem', 'important');
                
                if (sendBtn.parentElement) {
                    sendBtn.parentElement.style.setProperty('height', '24px', 'important');
                    sendBtn.parentElement.style.setProperty('min-height', '24px', 'important');
                    sendBtn.parentElement.style.setProperty('max-height', '24px', 'important');
                }
                
                const inputWrapper = document.getElementById('copilot-main-input-wrapper');
                if (inputWrapper) {
                    inputWrapper.style.setProperty('height', '30px', 'important');
                    inputWrapper.style.setProperty('min-height', '30px', 'important');
                }
            }
            if (emojiBtn) {
                emojiBtn.style.setProperty('height', '24px', 'important');
                emojiBtn.style.setProperty('width', '24px', 'important');
                emojiBtn.style.setProperty('min-width', '24px', 'important');
                emojiBtn.style.setProperty('max-width', '24px', 'important');
                emojiBtn.style.setProperty('font-size', '0.85rem', 'important');
            }
            if (gifBtn) {
                gifBtn.style.setProperty('height', '24px', 'important');
                gifBtn.style.setProperty('width', '24px', 'important');
                gifBtn.style.setProperty('min-width', '24px', 'important');
                gifBtn.style.setProperty('max-width', '24px', 'important');
                gifBtn.style.setProperty('font-size', '0.85rem', 'important');
            }
        } else {
            banner.style.removeProperty('height');
            if (commandConsole) {
                commandConsole.style.removeProperty('top');
                commandConsole.style.removeProperty('height');
            }
            if (mainScreen) {
                mainScreen.style.removeProperty('top');
                mainScreen.style.removeProperty('height');
            }
            if (playerContainer) {
                playerContainer.style.removeProperty('top');
                playerContainer.style.removeProperty('height');
            }
            if (copilotInput) {
                copilotInput.style.removeProperty('height');
                copilotInput.style.removeProperty('max-height');
                copilotInput.style.removeProperty('font-size');
            }
            if (mediaPillContainer) {
                mediaPillContainer.style.removeProperty('height');
                mediaPillContainer.style.removeProperty('min-height');
                mediaPillContainer.style.removeProperty('max-height');
            }
            if (sendBtn) {
                sendBtn.style.removeProperty('height');
                sendBtn.style.removeProperty('width');
                sendBtn.style.removeProperty('min-width');
                sendBtn.style.removeProperty('max-width');
                sendBtn.style.removeProperty('font-size');
            }
            if (emojiBtn) {
                emojiBtn.style.removeProperty('height');
                emojiBtn.style.removeProperty('width');
                emojiBtn.style.removeProperty('min-width');
                emojiBtn.style.removeProperty('max-width');
                emojiBtn.style.removeProperty('font-size');
            }
            if (gifBtn) {
                gifBtn.style.removeProperty('height');
                gifBtn.style.removeProperty('width');
                gifBtn.style.removeProperty('min-width');
                gifBtn.style.removeProperty('max-width');
                gifBtn.style.removeProperty('font-size');
            }
        }
    }

    
    repositionBanner();
    applyMobileStyles();
    if (titleBannerResizeHandler) {
        window.removeEventListener('resize', titleBannerResizeHandler);
    }
    titleBannerResizeHandler = () => {
        repositionBanner();
        applyMobileStyles();
    };
    window.addEventListener('resize', titleBannerResizeHandler);

    
    if (titleBannerObserver) {
        titleBannerObserver.disconnect();
    }
    titleBannerObserver = new MutationObserver(() => {
        if (window.innerWidth <= 768) {
            const isMobileConsoleView = document.body.classList.contains('mobile-view-console');
            const commandConsole = document.getElementById('command-console');
            const copilotInput = document.getElementById('copilot-input');
            const sendBtn = document.getElementById('copilot-send-btn');
            const emojiBtn = document.getElementById('copilot-emoji-btn');
            const gifBtn = document.getElementById('copilot-gif-btn');
            const mediaPillContainer = document.querySelector('.media-pill-container');

            
            if (commandConsole && isMobileConsoleView) {
                commandConsole.style.removeProperty('top');
            }

            if (copilotInput) {
                if (!isMobileConsoleView) {
                    copilotInput.style.setProperty('height', '24px', 'important');
                    copilotInput.style.setProperty('max-height', '24px', 'important');
                    copilotInput.style.setProperty('font-size', '0.85rem', 'important');
                } else {
                    
                    copilotInput.style.removeProperty('height');
                    copilotInput.style.removeProperty('max-height');
                    copilotInput.style.removeProperty('font-size');
                }
            }
            if (mediaPillContainer) {
                if (!isMobileConsoleView) {
                    mediaPillContainer.style.setProperty('height', '24px', 'important');
                    mediaPillContainer.style.setProperty('min-height', '24px', 'important');
                    mediaPillContainer.style.setProperty('max-height', '24px', 'important');
                } else {
                    
                    mediaPillContainer.style.removeProperty('height');
                    mediaPillContainer.style.removeProperty('min-height');
                    mediaPillContainer.style.removeProperty('max-height');
                }
            }
            if (sendBtn) {
                if (!isMobileConsoleView) {
                    sendBtn.style.setProperty('height', '24px', 'important');
                    sendBtn.style.setProperty('width', '24px', 'important');
                    sendBtn.style.setProperty('min-width', '24px', 'important');
                    sendBtn.style.setProperty('max-width', '24px', 'important');
                    sendBtn.style.setProperty('min-height', '24px', 'important');
                    sendBtn.style.setProperty('max-height', '24px', 'important');
                    sendBtn.style.setProperty('font-size', '0.85rem', 'important');
                    if (sendBtn.parentElement) {
                        sendBtn.parentElement.style.setProperty('height', '24px', 'important');
                        sendBtn.parentElement.style.setProperty('min-height', '24px', 'important');
                        sendBtn.parentElement.style.setProperty('max-height', '24px', 'important');
                    }
                    
                    const inputWrapper = document.getElementById('copilot-main-input-wrapper');
                    if (inputWrapper) {
                        inputWrapper.style.setProperty('height', '30px', 'important');
                        inputWrapper.style.setProperty('min-height', '30px', 'important');
                    }
                } else {
                    
                    sendBtn.style.removeProperty('height');
                    sendBtn.style.removeProperty('width');
                    sendBtn.style.removeProperty('min-width');
                    sendBtn.style.removeProperty('max-width');
                    sendBtn.style.removeProperty('min-height');
                    sendBtn.style.removeProperty('max-height');
                    sendBtn.style.removeProperty('font-size');
                    if (sendBtn.parentElement) {
                        sendBtn.parentElement.style.removeProperty('height');
                        sendBtn.parentElement.style.removeProperty('min-height');
                        sendBtn.parentElement.style.removeProperty('max-height');
                    }
                    const inputWrapperConsole = document.getElementById('copilot-main-input-wrapper');
                    if (inputWrapperConsole) {
                        inputWrapperConsole.style.removeProperty('height');
                        inputWrapperConsole.style.removeProperty('min-height');
                    }
                }
            }
            if (emojiBtn) {
                if (!isMobileConsoleView) {
                    emojiBtn.style.setProperty('height', '24px', 'important');
                    emojiBtn.style.setProperty('width', '24px', 'important');
                    emojiBtn.style.setProperty('min-width', '24px', 'important');
                    emojiBtn.style.setProperty('max-width', '24px', 'important');
                    emojiBtn.style.setProperty('font-size', '0.85rem', 'important');
                } else {
                    
                    emojiBtn.style.removeProperty('height');
                    emojiBtn.style.removeProperty('width');
                    emojiBtn.style.removeProperty('min-width');
                    emojiBtn.style.removeProperty('max-width');
                    emojiBtn.style.removeProperty('font-size');
                }
            }
            if (gifBtn) {
                if (!isMobileConsoleView) {
                    gifBtn.style.setProperty('height', '24px', 'important');
                    gifBtn.style.setProperty('width', '24px', 'important');
                    gifBtn.style.setProperty('min-width', '24px', 'important');
                    gifBtn.style.setProperty('max-width', '24px', 'important');
                    gifBtn.style.setProperty('font-size', '0.85rem', 'important');
                } else {
                    
                    gifBtn.style.removeProperty('height');
                    gifBtn.style.removeProperty('width');
                    gifBtn.style.removeProperty('min-width');
                    gifBtn.style.removeProperty('max-width');
                    gifBtn.style.removeProperty('font-size');
                }
            }
        }
    });

    
    titleBannerObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['style'],
        subtree: true
    });

    
    const savedCollapsed = localStorage.getItem('titleBannerCollapsed') === 'true';
    if (savedCollapsed && window.innerWidth > 768) {
        banner.classList.add('collapsed');
        document.body.classList.add('banner-collapsed');
    }

    
    const mobileHeader = document.getElementById('app-header');
    if (mobileHeader && !mobileHeader.dataset.collapseInit) {
        mobileHeader.dataset.collapseInit = '1';

        
        const headerRight = document.getElementById('header-right');

        if (localStorage.getItem('mobileHeaderCollapsed') === 'true') {
            mobileHeader.classList.add('mobile-collapsed');
            
            if (headerRight) headerRight.style.display = 'none';
        } else {
            
            if (headerRight) {
                headerRight.style.display = 'none';
                setTimeout(() => {
                    headerRight.style.display = 'flex';
                    headerRight.style.opacity = '0';
                    headerRight.style.transition = 'opacity 1s ease';
                    
                    void headerRight.offsetHeight;
                    headerRight.style.opacity = '1';
                }, 300);
            }
        }

        mobileHeader.addEventListener('click', (e) => {
            if (window.innerWidth > 768) return;

            const isCollapsed = mobileHeader.classList.contains('mobile-collapsed');
            const headerRight = document.getElementById('header-right');

            if (isCollapsed) {
                mobileHeader.classList.remove('mobile-collapsed');
                localStorage.setItem('mobileHeaderCollapsed', 'false');

                
                if (headerRight) {
                    headerRight.style.display = 'none';
                    setTimeout(() => {
                        headerRight.style.display = 'flex';
                        headerRight.style.opacity = '0';
                        headerRight.style.transition = 'opacity 1s ease';
                        
                        void headerRight.offsetHeight;
                        headerRight.style.opacity = '1';
                    }, 300);
                }
            } else {
                mobileHeader.classList.add('mobile-collapsed');
                localStorage.setItem('mobileHeaderCollapsed', 'true');

                
                if (headerRight) {
                    headerRight.style.display = 'none';
                }
            }
        });
    }

    
    banner.addEventListener('click', () => {
        if (window.innerWidth <= 768) return;

        const isCollapsed = banner.classList.contains('collapsed');

        if (isCollapsed) {
            localStorage.setItem('titleBannerCollapsed', 'false');
            banner.classList.remove('collapsed');
            document.body.classList.remove('banner-collapsed');
        } else {
            localStorage.setItem('titleBannerCollapsed', 'true');
            banner.classList.add('collapsed');
            document.body.classList.add('banner-collapsed');
        }
    });
}


export function getActiveChannel() {
    return currentChannel;
}


export async function setActiveChannel(channelName) {
    
    const previousChannel = currentChannel;
    currentChannel = channelName;

    
    if (previousChannel === 'artist' && channelName !== 'artist') {
        const { closeAllDetailsPanels } = await import('../components/profile/profile_dom.js');
        closeAllDetailsPanels();
    }

    
    if (previousChannel === 'sonic-lounge' && channelName !== 'sonic-lounge') {
        const { closeCustomizationMode } = await import('../components/sonic_lounge/loungeUIManager.js');
        closeCustomizationMode();
    }
    
    const channelTitle = document.getElementById('channel-title');
    
    document.querySelectorAll('.channel').forEach(c => c.classList.remove('active-channel'));
    document.querySelectorAll('.nav-item').forEach(i => i.classList.remove('active'));

    const channelEl = document.getElementById(`channel-${channelName}`);
    const navItemEl = document.querySelector(`.nav-item[data-channel="${channelName}"]`);
    
    if (channelEl) channelEl.classList.add('active-channel');
    if (navItemEl) navItemEl.classList.add('active');
    
    if (channelTitle) {
        const titles = {
            'sonic-lounge': 'Octave11',
            'artist': 'Artist',
            'account': 'Account',
            'customization': 'Customization',
            'arcade': 'Arcade'
        };
        channelTitle.textContent = titles[channelName] || 'Octave11';
    }

    if (!initializedChannels.has(channelName)) {
        switch (channelName) {
            case 'artist': {
                const { initializeLibraryChannel } = await import('../components/profileChannelManager.js');
                initializeLibraryChannel();
                break;
            }
            case 'account': {
                const { initializeAccountChannel } = await import('../components/accountChannelManager.js');
                initializeAccountChannel();
                break;
            }
            case 'arcade': {
                const arcadeManager = (await import('../components/arcadeManager.js')).default;
                arcadeManager.initialize();
                break;
            }
        }
        initializedChannels.add(channelName);
        log.info(`Initialized channel: ${channelName}`);
    }

    
    if (channelName === 'account') {
        const { getActiveAccountTab } = await import('../components/profile/profile_state.js');
        const savedTab = getActiveAccountTab();
        
        const accountTabs = document.querySelectorAll('.account-editor-tab');
        const accountPanels = document.querySelectorAll('.account-editor-panel');
        accountTabs.forEach(t => t.classList.remove('active'));
        accountPanels.forEach(p => p.classList.remove('active'));
        const targetTab = document.querySelector(`.account-editor-tab[data-tab="${savedTab}"]`);
        const targetPanel = document.getElementById(`account-${savedTab}-panel`);
        if (targetTab) targetTab.classList.add('active');
        if (targetPanel) targetPanel.classList.add('active');
    }

    if (channelName === 'badges') {
        
        const isGuest = useAppStore.getState().isGuest;
        if (isGuest) {
            addNotification('Must be logged in to collect coins!', { type: 'warning', duration: 4000 });
            
            
            import('./notificationsManager.js').then(module => {
                if (module.updateScrollingNotificationText) {
                    module.updateScrollingNotificationText('Must be logged in to collect coins!', 'coin', 'fa-trophy');
                }
            }).catch(err => {
                console.warn('[Navigation] Could not import notificationsManager:', err);
            });

            import('../components/chatBannerManager.js').then(({ openHubModal }) => {
                openHubModal();
            }).catch(() => {});
        }
        
        window.dispatchEvent(new CustomEvent('badge:refresh'));
    }

    
    const channelUploadBtn = document.getElementById('channel-upload-btn');
    if (channelUploadBtn) {
        if (channelName === 'sonic-lounge') {
            channelUploadBtn.style.display = 'flex';
        } else {
            channelUploadBtn.style.display = 'none';
        }
    }

    
    if (channelName === 'sonic-lounge') {
        document.body.classList.add('channel-sonic-lounge');
    } else {
        document.body.classList.remove('channel-sonic-lounge');
    }
}